import React from 'react';

function Footer() {
    return (
        <footer id="footer" className="footer">
            <div className="copyright">
                © Copyright <strong><span>Vraj Prachin Ayurved Chikitsa Kendra</span></strong>. All Rights Reserved
            </div>
            {<div className="credits">
                <a href="https://b12greenfood.com/">B12GreenFood</a>
            </div>}
        </footer>
    );
}

export default Footer;
